export default __webpack_public_path__ + "static/media/3043.d1fcd332.jpg";